import { render } from "./CustomerManifestDashboardMenu.vue?vue&type=template&id=6ab40fbe&scoped=true"
import script from "./CustomerManifestDashboardMenu.vue?vue&type=script&lang=js"
export * from "./CustomerManifestDashboardMenu.vue?vue&type=script&lang=js"

import "./CustomerManifestDashboardMenu.vue?vue&type=style&index=0&id=6ab40fbe&scoped=true&lang=css"

import exportComponent from "C:\\Users\\blake\\LREX-site\\lrex-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ab40fbe"]])

export default __exports__